import { ref, onMounted, watch } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useRequeteItemWithoutConnexion(props) {
    const showModalAnomalieIn = ref(false);
    const anomalies = ref([]);
    const nomChamps = ref([]);

    watch(anomalies, (newAnomalies) => {
        nomChamps.value = [];
        if (newAnomalies.length > 0) {
            for (let i = 0; i < newAnomalies[0].champsLigneAnomalie.length; i++) {
                nomChamps.value.push(newAnomalies[0].champsLigneAnomalie[i].nomChamp);
            }
        }
    });

    const getAnomaliesToJustifWithoutConnexion = async () => {
        try {
            const data = await http.getAnomaliesToJustifOffline(props.idExecution, props.requete.idRequete);
            anomalies.value = data;
        } catch (error) {
            console.error("Erreur lors de la récupération des anomalies:", error);
        }
    };

    const handleShowModalAnomalieIn = async (idExecution, idRequete) => {
        try {
            const data = await http.getAnomaliesToJustifOffline(idExecution, idRequete);
            anomalies.value = data;
        } catch (error) {
            console.error("Erreur lors de l'affichage des anomalies:", error);
        }
        showModalAnomalieIn.value = !showModalAnomalieIn.value;
    };

    onMounted(() => {
        eventBus.on('reloadAnomaliesToJustifWithoutCo', getAnomaliesToJustifWithoutConnexion);
    });

    return {
        showModalAnomalieIn,
        anomalies,
        nomChamps,
        handleShowModalAnomalieIn,
    };
}